const tiiviiBackendUrl = process.env.BACKEND_URL;
export const cinfoPageUrl = "https://cinfo.es";
export const getEmbeddedPlayerUrl = ({ eventId, locale }) =>
  `${process.env.EMBEDDED_PLAYER_URL}?locale=${locale}&eventId=${eventId}`;

export const tiiviiLogo = "/static/images/tiivii-small.png";
export const tiiviiIcon = "/static/images/Isotipo_tiivii.svg";
export const tiiviiIconBlack = "/static/images/Isotipo_tiivii_black.svg";
export const tiiviiIconDisabled = "/static/images/Isotipo_tiivii_disabled.svg";
export const twitchIcon = "/static/images/Isotipo_Twitch.svg";
export const twitchIconBlack = "/static/images/Isotipo_Twitch_black.svg";
export const twitchIconDisabled = "/static/images/Isotipo_Twitch_disabled.svg";
export const dailymotionIcon = "/static/images/Isotipo_Dailymotion.svg";
export const dailymotionIconBlack = "/static/images/Isotipo_Dailymotion_black.svg";
export const dailymotionIconDisabled = "/static/images/Isotipo_Dailymotion_disabled.svg";
export const cinfoLogo = "/static/images/cinfo-small.png";
export const getHelpUrl = docLocale => `/docs/${docLocale}/`;

export const androidApp = "https://play.google.com/store/apps/details?id=com.streamaxia.broadcastme&hl=en";
export const iOSApp = "https://apps.apple.com/us/app/broadcast-me/id491982406";

export const androidAppLarix = "https://play.google.com/store/apps/details?id=com.wmspanel.larix_broadcaster";
export const iOSAppLarix = "https://apps.apple.com/us/app/larix-broadcaster/id1042474385";

export const tiiviiGraphqlUrl = `${tiiviiBackendUrl}/graphql`;
export const authTokenUrl = `${tiiviiBackendUrl}/api/1/tokens`;
export const jwtPlayerScriptUrl = "https://cdn.jwplayer.com/libraries/YvMrcKTn.js";
export const localesUrl = `${tiiviiBackendUrl}/api/1/locales`;

export const getLoggerLevelsUrl = token => `${tiiviiBackendUrl}/api/1/logger/levels?token=${token}`;
export const getLoggerCurrentLevelUrl = token => `${tiiviiBackendUrl}/api/1/logger/currentLevel?token=${token}`;
export const getChangeLogLevelUrl = (logLevel, token) => `${tiiviiBackendUrl}/api/1/logger/${logLevel}?token=${token}`;

export const trackUserAction = token => `${tiiviiBackendUrl}/api/1/tracking?token=${token}`;
export const sendError = token => `${tiiviiBackendUrl}/api/1/error?token=${token}`;

export const uploadVideoAssetFormUrl = token => `${tiiviiBackendUrl}/api/1/assets?token=${token}`;
export const uploadCustomerVideoAssetFormUrl = (customerId, token) =>
  `${tiiviiBackendUrl}/api/1/customers/${customerId}/assets?token=${token}`;

export const getImgPathCustomerAsset = (asset, token) =>
  asset && asset.id && asset.customerId
    ? `${tiiviiBackendUrl}/customers/${asset.customerId}/assets/${asset.id}/file?token=${token}`
    : null;
export const getImgPathAsset = (asset, token) =>
  asset && asset.id ? `${tiiviiBackendUrl}/assets/${asset.id}/file?token=${token}` : null;
export const getRecordingFileUrl = (recordingId, fileId, token) =>
  `${tiiviiBackendUrl}/recording/${recordingId}/file/${fileId}/download?token=${token}`;
export const getSourceThumbnail = (sourceId, token) =>
  `${tiiviiBackendUrl}/sources/${sourceId}/thumbnail?token=${token}`;
export const getRefreshedSourceThumbnail = (sourceId, token) =>
  `${tiiviiBackendUrl}/sources/${sourceId}/thumbnailRefreshed?token=${token}`;
export const getRoomTemplateFileUrl = ({ id, contractId, token }) =>
  `${tiiviiBackendUrl}/roomTemplate/${id}/contractId/${contractId}/download?token=${token}`;
export const getScoreboardTemplateImg = ({ contractId, scoreboardTemplateId, token }) =>
  `${tiiviiBackendUrl}/scoreboardTemplate/${scoreboardTemplateId}/contract/${contractId}/img?token=${token}`;
export const getScoreboardTemplateThumbnail = ({ contractId, scoreboardTemplateId, token }) =>
  `${tiiviiBackendUrl}/scoreboardTemplate/${scoreboardTemplateId}/contract/${contractId}/thumbnail?token=${token}`;
export const getScoreboardPreviewUrl = ({ eventId, token }) =>
  `${tiiviiBackendUrl}/scoreboardTemplate/preview/event/${eventId}?token=${token}`;
export const getScoreboardFormPreviewUrl = ({ token, contractId }) =>
  `${tiiviiBackendUrl}/scoreboardTemplate/preview/contract/${contractId}?token=${token}`;
